import React, { useContext, useEffect, useState } from "react";

import { DataContext } from "../context/DataContext";
import supabase from "../supabase/supabaseClient";

import estiloA from "./styles/FotoA.module.css";
import estiloB from "./styles/FotoB.module.css";

import { Link } from "react-router-dom";

function Foto({ usuario, tiempo, variante }) {
  const { urlFotos } = useContext(DataContext);

  const [fotos, setFotos] = useState(false);

  const estilo = variante === "inicio" ? estiloA : estiloB;

  useEffect(() => {
    const fetchFotos = async () => {
      const { data } = await supabase.storage.from("fotos").list(`${usuario}`, {
        limit: 100,
        offset: 0,
        sortBy: { column: "name", order: "asc" },
      });

      if (data) {
        // console.log("foto", data);
        setFotos(data[0]);
      }
    };

    fetchFotos();
  }, [usuario]);

  return (
    <div className={estilo.foto}>
      {fotos && (
        <Link to={"/" + fotos.name}>
          <img src={urlFotos + usuario + "/" + fotos.name} alt="f" />
          <p>
            {Math.floor(tiempo / 60)}:
            {Math.floor(tiempo % 60)
              .toString()
              .padStart(2, "0")}{" "}
          </p>
        </Link>
      )}
    </div>
  );
}

export default Foto;
